import { Button, Box, IconButton } from '@mui/material'
import { Upload } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import VideoModal from './VideoModal'
import { useState } from 'react';

export default function UploadButton(props) {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);

    return (
        <Box sx={{ marginLeft: 'auto', maxHeight: '2rem' }}>
            {window.innerWidth < 444
                ? <IconButton
                    sx={{ background: "#4CA3FC", borderRadius: 1 }}
                    onClick={handleOpen}
                    id='upload-btn'
                >
                    <Upload color="secondary" />
                </IconButton>
                : <Button
                    sx={{
                        background: "#4CA3FC",
                        textTransform: "none",
                        padding: "9px 28px"
                    }}
                    variant="contained"
                    startIcon={<Upload />}
                    onClick={handleOpen}
                    id='upload-btn'
                >
                    Upload
                </Button>}
            <VideoModal open={open} setOpen={setOpen} />
        </Box>
    )
}